import React from 'react';

import NavbarOut from './NavbarOut';
import './styles/Layout.css';

function LayoutOut(props) {
  return (
    <div className="app-shell">
      <NavbarOut />
      <main className="app-shell__main">{props.children}</main>
    </div>
  );
}

export default LayoutOut;
